import ViewListOutlinedIcon from "@mui/icons-material/ViewListOutlined";
import { Box, Typography } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { FONT_SIZE, INK } from "../../../theme/tokens";
import SystemButton from "../../UIToolkit/SystemButton/SystemButton";

type Props = {
	shownCount: number;
	totalCount: number;
	/** Rows the next "Show more" adds; 0 once every row is showing. */
	showMoreCount: number;
	onShowMore: () => void;
	onOpenOnTeam: () => void;
};

/** Under a long Not assigned list: how much of it is showing, a way to show more, and a way to the Team list. */
export const HolidayNotAssignedFooter: FC<Props> = ({ shownCount, totalCount, showMoreCount, onShowMore, onOpenOnTeam }) => {
	const { t } = useTranslation();
	return (
		<Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 1, pt: 1.5, px: 1.5 }}>
			<Typography sx={{ color: INK.MUTED, fontSize: FONT_SIZE.SECONDARY }} data-testid="holiday-not-assigned-shown">
				{t("holidays.notAssigned.shown", { shown: shownCount, count: totalCount })}
			</Typography>
			<Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 1 }}>
				{showMoreCount > 0 && (
					<SystemButton buttonVariant="borderless" size="small" onClick={onShowMore} noFullWidthMobile data-testid="holiday-not-assigned-show-more">
						{t("holidays.notAssigned.showMore", { count: showMoreCount })}
					</SystemButton>
				)}
				<SystemButton
					buttonVariant="borderless"
					size="small"
					leadingIcon={<ViewListOutlinedIcon fontSize="small" />}
					onClick={onOpenOnTeam}
					noFullWidthMobile
					data-testid="holiday-not-assigned-open-team"
				>
					{t("holidays.notAssigned.openOnTeam")}
				</SystemButton>
			</Box>
		</Box>
	);
};
